import { render, staticRenderFns } from "./updatePass.vue?vue&type=template&id=22139566&scoped=true"
import script from "./updatePass.vue?vue&type=script&lang=js"
export * from "./updatePass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22139566",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\dm\\longda\\web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22139566')) {
      api.createRecord('22139566', component.options)
    } else {
      api.reload('22139566', component.options)
    }
    module.hot.accept("./updatePass.vue?vue&type=template&id=22139566&scoped=true", function () {
      api.rerender('22139566', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/user/center/updatePass.vue"
export default component.exports